import { Injectable } from '@angular/core';

import { SurveyBhUserGrpcContractService } from '@lyra/app/core/api/grpc';
import { ErrorService } from '@lyra/app/core/services/error.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs';

import { Survey } from '../../classes/survey.class';
import * as actions from '../actions/survey.actions';
import { IQuestionnaireState } from '../states/questionnaire.state';

@Injectable()
export class SurveyEffects {
  init$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.INITIALIZE_COMMAND),
      switchMap(({ goalIds }) =>
        this._surveyBhUserGrpcContractService
          .initialize({
            StatisticsOnly: false,
            GoalIds: goalIds ?? [],
          })
          .pipe(
            map((response) => actions.INITIALIZE_SUCCESS({ survey: new Survey({ Id: response.SurveyId }) })),
            catchError((response) =>
              this._errorService.handleApiError(response, 'SurveyBhUserWebGrpcContractClient.Init'),
            ),
          ),
      ),
    ),
  );

  constructor(
    private _store$: Store<IQuestionnaireState>,
    private _actions$: Actions,
    private _errorService: ErrorService,
    private _surveyBhUserGrpcContractService: SurveyBhUserGrpcContractService,
  ) {}
}
